const baseRequired = (obj, message = " ") => {
  return {
    validator: (rule, value, callback) => {
      if (obj.Required !== false) {
        if (value === "" || value === undefined || value === null) {
          callback(new Error(message));
        } else if (value instanceof Array && value.length === 0) {
          callback(new Error(message));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    message: message,
    trigger: "change",
  };
};

const arrayRequired = (obj, message = " ") => {
  // return {
  //   required: obj.Required !== false, message: message, type: 'array'
  // }
  return {
    validator: (rule, value, callback) => {
      if (obj.Required !== false) {
        if (value.length) {
          callback();
        } else {
          callback(new Error(message));
        }
      } else {
        callback()
      }
    },
  };
};

const dateRequired = (obj, message = " ") => {
  return {
    required: obj.required !== false,
    message: message,
    type: "date",
  };
};

const latestYearsRequired = (obj, message = " ", $vm) => {
  return {
    validator: (rule, value, callback) => {
      let { form } = $vm;
      let { Key } = obj;
      let msg = "";
      let list = form[`${Key}_LIST`];
      if (obj.Required === false) {
        callback();
      } else if (/^\d+$/.test(value)) {
        list.forEach((v) => {
          if (!/^\d+$/.test(v)) {
            msg = " ";
          }
        });
        if (msg) {
          callback(new Error(msg));
        } else {
          callback();
        }
      } else {
        callback(new Error(" "));
      }
    },
  };
};

const required = (obj, param, $vm) => {
  switch (param.componentId) {
    case "editor":
      return baseRequired(obj, `${obj.Name}不能为空`);
    case "latestYears":
      return latestYearsRequired(obj, ` `, $vm);
    case "checkbox":
      return arrayRequired(obj, ` `, $vm);
    default:
      return baseRequired(obj, obj.ShowRequired ? `${obj.Name}` : ` `);
  }
};

const patternConfig = {
  fax: new RegExp(/^(((\d{3,4}-)?\d{4,10}){0,1}|\/)$/),
  phone: new RegExp(/^((\d{3,4}-)?\d{4,10}){0,1}$/),
  mulPhone: new RegExp(/^((\d{3,4}-)?\d{6,10}|(\+\d{0,4})?1[3-9]\d{9}|[,，、\/]){1,}$/),
  cell: new RegExp(/^((\+\d{0,4})?1[3-9]\d{9})$/),
  cellOrPhone: new RegExp(/^(((\+\d{0,4})?1[3-9]\d{9})|((\d{3,4}-)?\d{6,10})){0,1}$/),
  url: new RegExp(/^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i),
  email: new RegExp(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/),
  post: new RegExp(/^\d{6}(?!\d)$/),
  officialCard: new RegExp(
    /(^南字第(\d{8})号$)|(^北字第(\d{8})号$)|(^沈字第(\d{8})号$)|(^兰字第(\d{8})号$)|(^成字第(\d{8})号$)|(^济字第(\d{8})号$)|(^广字第(\d{8})号$)|(^海字第(\d{8})号$)|(^空字第(\d{8})号$)|(^参字第(\d{8})号$)|(^政字第(\d{8})号$)|(^后字第(\d{8})号$)|(^装字第(\d{8})号$)|(^士字第(\d{8})号$)/
  ),
  passport: new RegExp(/(^P\d{7,8}$)|(^G\d{8}$)|(^E\d{8}$)|(^S\d{7}$)|(^D\d{8}$)|(^[A-Z0-9]{9}$)/),
  twPassport: new RegExp(/^\d{8}$/),
};

const patternValid = (obj, type) => {
  return {
    validator: (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (patternConfig[type].test(value)) {
        callback();
      } else {
        callback(new Error(`请正确填写${obj.Name}`));
      }
    },
  };
};

const patternCustom = (obj, pattern, message) => {
  return {
    validator: (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (pattern.test(value)) {
        callback();
      } else {
        callback(new Error(message));
      }
    },
  };
};

const totalValidWithNumber = ($vm, total, keys, message) => {
  return {
    validator: (rule, value, callback) => {
      let values = [];
      let { form } = $vm;
      keys.forEach((key) => {
        values.push(form[key]);
      });
      if (values === "") {
        callback();
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请填写数字"));
      } else if (values.indexOf("") >= 0) {
        callback();
      } else {
        let _total = values.reduce((t, c) => {
          return t - -c;
        }, 0);
        if (_total - total === 0) {
          callback();
        } else {
          callback(new Error(message));
        }
      }
    },
  };
};

const totalValidWithKey = ($vm, key, keys, message) => {
  return {
    validator: (rule, value, callback) => {
      let { form } = $vm;
      let values = [];
      let total = form[key];
      keys.forEach((key) => {
        values.push(form[key]);
      });
      if (value === "") {
        callback();
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请填写数字"));
      } else if (values.indexOf("") >= 0) {
        callback();
      } else {
        let _total = values.reduce((t, c) => {
          return t - -c;
        }, 0);
        if (_total - total === 0) {
          callback();
        } else {
          callback(new Error(message));
        }
      }
    },
  };
};

const numberValidWithDecimal = (decLength, spValues = [], excludeZero = false) => {
  if (spValues.length) spValues = `|${spValues.join("|")}`;
  let spValuesTip = spValues.length ? spValues.replace("|", "或填写").replace(/\|/g, "、") : "";
  let obj = null;
  if (decLength === 0) {
    obj = {
      pattern: new RegExp(`^(${excludeZero ? "[1-9]" : "\\d"}\\d*${spValues})$`),
      message: `请填写大于${excludeZero ? "" : "等于"}0的整数${spValuesTip}`,
    };
  } else if (decLength > 0) {
    obj = {
      pattern: new RegExp(`^(\\d+(\\.\\d{${decLength}})${spValues})$`),
      message: `请保留${decLength}位小数${spValuesTip}`,
    };
  } else {
    obj = {
      pattern: new RegExp(`^(\\d+(\\.\\d+)?${spValues})$`),
      message: `请填写数字${spValuesTip}`,
    };
  }
  let tempRule = {
    validator: (rule, value, callback) => {
      if (!tempRule.required && value === "") {
        callback();
      } else if (obj.pattern.test(value)) {
        callback();
      } else {
        callback(new Error(obj.message));
      }
    }
  }
  return tempRule
};

const numberRange = (min, max, message) => {
  return {
    validator: (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请填写数字"));
      } else {
        let num = 0 - -value;
        if (num <= max && num >= min) {
          callback();
        } else {
          callback(new Error(message));
        }
      }
    },
  };
};

const numberValidWithMaxDecimal = (decLength, spValues = []) => {
  if (spValues.length) spValues = `|${spValues.join("|")}`;
  let spValuesTip = spValues.length ? spValues.replace("|", "或填写").replace(/\|/g, "、") : "";
  let obj = {
    pattern: new RegExp(`^((\\d+(\\.\\d{1,${decLength}})?)${spValues})$`),
    message: `请填写数字（最多保留${decLength}位小数）${spValuesTip}`,
  }
  return {
    validator: (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (obj.pattern.test(value)) {
        callback();
      } else {
        callback(new Error(obj.message));
      }
    },
  };
}

const idCardNoValid = (rule, value, callback, source, options) => {
  const res =
    idCardNoValidForMainLand.valid(value) || idCardNoValidForTW.valid(value) || idCardNoValidForHK.valid(value) || idCardNoValidForAM.valid(value);
  if (value === "") {
    callback();
  } else if (res) {
    callback();
  } else {
    callback(new Error(rule.message));
  }
};

const limitTextLength = (obj, min, max) => {
  return {
    validator: (rule, value, callback) => {
      if (value === "") return callback();

      value = value.replace(/[^\u0000-\u00ff]/g, "aa");
      if (value.length < min) {
        callback(new Error(`最少输入${min}个字符（每个汉字算2个字符）`));
      } else if (value.length > max) {
        callback(new Error(`最多输入${max}个字符（每个汉字算2个字符）`));
      } else {
        callback();
      }
    },
  };
};

const customValidator = (obj, $vm, trigger, args) => {
  return {
    trigger: trigger,
    validator: (rule, value, callback) => {
      $vm.setCustomValidate({ obj, args, value, callback });
    },
  };
};

const houseRules = (obj, $vm, trigger, args, noisy) => {
  return {
    trigger: trigger,
    validator: (rule, value, callback) => {
      $vm.houseRules({ obj, args, value, callback, noisy });
    },
  };
};

const trafficRules = (obj, $vm, trigger, args, noisy) => {
  return {
    trigger: trigger,
    validator: (rule, value, callback) => {
      $vm.trafficRules({ obj, args, value, callback, noisy });
    },
  };
};

// 大陆身份证
const idCardNoValidForMainLand = {
  valid(idNo) {
    return idNo && this.validPattern(idNo) && this.validProvinceId(idNo.slice(0, 2)) && this.validDate(idNo.slice(6, 14)) && this.validLastNum(idNo);
  },
  validPattern(no) {
    return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[012]))(([0-2]\d)|3[01])\d{3}([\dxX]{1})$/.test(no);
  },
  validProvinceId(a) {
    const list = [
      "11",
      "12",
      "13",
      "14",
      "15",
      "21",
      "22",
      "23",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "50",
      "51",
      "52",
      "53",
      "54",
      "61",
      "62",
      "63",
      "64",
      "65",
      "71",
      "81",
      "82",
      "91",
    ];
    return list.indexOf(a) >= 0;
  },
  validDate(d) {
    return new Date(d.slice(0, 4) + "/" + d.slice(4, 6) + "/" + d.slice(6, 8)).toString() !== "Invalid Date";
  },
  validLastNum(no) {
    const a = no.toUpperCase().split("");
    const b = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const c = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
    const d = a.pop();
    let sum = 0;
    while (a.length) {
      sum += a.pop() * b[a.length];
    }
    return c[sum % 11] === d;
  },
};
// 台湾身份证
const idCardNoValidForTW = {
  valid(idNo) {
    return idNo && this.validPattern(idNo) && this.validLastNum(idNo);
  },
  validPattern(no) {
    return /^[A-Z][12]\d{8}$/.test(no);
  },
  validLastNum(no) {
    const a = no.split("");
    const b = {
      A: 10,
      B: 11,
      C: 12,
      D: 13,
      E: 14,
      F: 15,
      G: 16,
      H: 17,
      I: 34,
      J: 18,
      K: 19,
      L: 20,
      M: 21,
      N: 22,
      O: 35,
      P: 23,
      Q: 24,
      R: 25,
      S: 26,
      T: 27,
      U: 28,
      V: 29,
      W: 32,
      X: 30,
      Y: 31,
      Z: 33,
    };
    const c = b[a[0]] + "";
    const d = "987654321".split("");
    const e = a.pop();
    let sum = c[0];
    a[0] = c[1];
    while (d.length) {
      sum -= -(a.pop() * d.pop());
    }
    return sum % 10 === (10 - e) % 10;
  },
};
// 香港身份证
const idCardNoValidForHK = {
  valid(idNo) {
    return idNo && this.validPattern(idNo) && this.validLastNum(idNo);
  },
  validPattern(no) {
    return /^[A-Z]\d{6}[(（][A\d][）)]$/.test(no);
  },
  validLastNum(no) {
    const x = " ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const y = [7, 6, 5, 4, 3, 2];
    const z = ["0", "A", "9", "8", "7", "6", "5", "4", "3", "2", "1"];

    const a = x.indexOf(no[0]);
    const b = no.slice(1, 7).split("");
    const c = no[8];

    let sum = a * 8;
    let len = 6;
    while (len-- > 0) {
      sum += y[len] * b[len];
    }

    return z[sum % 11] === c;
  },
};
// 澳门身份证
const idCardNoValidForAM = {
  valid(idNo) {
    return idNo && this.validPattern(idNo);
  },
  validPattern(no) {
    return /^[157]\d{6}[(（][\d][）)]$/.test(no);
  },
};

// 统一社会信用代码
const fnValidSocietyCode = function (value) {
  let arr = value.split("");
  let Ci = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "T",
    "U",
    "W",
    "X",
    "Y",
  ];
  let Wi = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
  let sum = 0;
  let lastItem = Ci.indexOf(arr.pop());
  arr.forEach((v, k) => {
    sum += Ci.indexOf(v) * Wi[k];
  });
  sum = (31 - (sum % 31)) % 31;
  return fnValidOrgCode(value.slice(8, 17)) && sum - lastItem === 0;
};
// 统一社会信用代码2号：不验证最后一位的值
const fnValidSocietyCodeFaker = function (value) {
  // 只验证其中包含的组织机构代码
  return fnValidOrgCode(value.slice(8, 17));
};

// 组织机构代码
const fnValidOrgCode = function (value) {
  let arr = value.split("");
  let Ci = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  let Wi = [3, 7, 9, 10, 5, 8, 4, 2];
  let sum = 0;
  let last = arr.pop();
  arr.forEach((v, k) => {
    sum += Ci.indexOf(v) * Wi[k];
  });
  sum = (11 - (sum % 11)) % 11;
  return sum === 10 ? last === "X" : last - sum === 0;
};
// 组织机构代码
const orgCode = (obj) => {
  return {
    message: "请输入正确的" + obj.Name,
    validator(rule, value, callback) {
      if (value.length === 9) {
        if (/^[A-Z\d]{9}$/.test(value) && fnValidOrgCode(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的" + obj.Name));
        }
      } else {
        callback(new Error("请输入正确的" + obj.Name));
      }
    },
  };
};
// 社会信用代码
const societyCode = (obj) => {
  return {
    message: "请输入正确的" + obj.Name,
    validator(rule, value, callback) {
      if (value.length === 18) {
        if (/^\w{2}\d{6}\w{10}$/.test(value) && !/[IOZSVa-z]/.test(value) && fnValidSocietyCodeFaker(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的" + obj.Name));
        }
      } else {
        callback(new Error("请输入正确的" + obj.Name));
      }
    },
  };
};

const orgOrSociety = (obj, isStrict = false) => {
  return {
    message: "请输入正确的" + obj.Name,
    validator(rule, value, callback) {
      // callback()
      if (value === "") {
        callback();
      } else if (value.length === 9) {
        if (/^[A-Z\d]{9}$/.test(value) && (!isStrict || fnValidOrgCode(value))) {
          callback();
        } else {
          callback(new Error(`请输入正确的${obj.Name}`));
        }
      } else if (value.length === 18) {
        if (/^\w{2}\d{6}\w{10}$/.test(value) && !/[IOZSVa-z]/.test(value) && (!isStrict || fnValidSocietyCodeFaker(value))) {
          callback();
        } else {
          callback(new Error(`请输入正确的${obj.Name}`));
        }
      } else {
        callback(new Error(`请输入正确的${obj.Name}`));
      }
    },
  };
};

export default {
  arrayRequired,
  dateRequired,
  required,
  totalValidWithNumber,
  totalValidWithKey,
  numberValidWithDecimal,
  patternValid,
  patternCustom,
  idCardNoValid,
  limitTextLength,
  customValidator,
  trafficRules,
  houseRules,
  orgCode,
  societyCode,
  orgOrSociety,
  numberRange,
  fnValidOrgCode,
  numberValidWithMaxDecimal,
  fnValidSocietyCodeFaker,
};
